export default {
  requiredFilters: 1,
};
